/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCLeftIcon20Light = forwardRef('ArrowCLeftIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.978 16.604a.5.5 0 0 1-.707 0l-4.836-4.836a2.5 2.5 0 0 1 0-3.536l4.836-4.836a.5.5 0 1 1 .707.707L8.142 8.94a1.5 1.5 0 0 0 0 2.121l4.836 4.836a.5.5 0 0 1 0 .708Z" })));
});
